import type { FieldKind } from 'app/generated/modelFieldTypes'

// Reverses the stringified from/to changelog pushed over the WebSocket into a
// typed store patch, keyed by the field-kind map. Every leaf arrives as a
// string (or a native value for scalar arrays); this restores the store shape.

export function coerce(
  data: Record<string, { to?: unknown }>,
  fieldTypes: Record<string, FieldKind>,
): Record<string, unknown> {
  const patch: Record<string, unknown> = {}

  for (const [field, change] of Object.entries(data)) {
    // Dotted keys (e.g. `pipelines.key`) are API search-only sub-field artifacts, not store fields.
    if (field.includes(`.`)) continue
    const to = change.to
    if (to === undefined) continue
    if (to === null) {
      patch[field] = null
      continue
    }

    switch (fieldTypes[field]) {
      case `int`:
      case `float`:
        patch[field] = Number(to)
        break
      case `boolean`:
        patch[field] = to === `true` || to === true
        break
      case `list`:
      case `object`:
        patch[field] = typeof to === `string` ? JSON.parse(to) : to
        break
      // datetime stays an ISO string, string passes through, and an unknown
      // field falls back to its raw value to tolerate schema/map drift.
      default:
        patch[field] = to
    }
  }

  return patch
}
